export const SUSPENDED_LOCATION_STATUS = ["DISCONNECTED", "DUPLICATED", "IS_SUSPENDED", "NOT_VERIFIED"]
